var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenHollow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 0.390503L15.6095 3.33331L12.8052 6.13763C12.805 6.13777 12.8053 6.13749 12.8052 6.13763C12.805 6.13777 12.8045 6.13833 12.8043 6.13847L3.60948 15.3333H0.666672L0.666672 12.3905L9.8616 3.19557C9.86149 3.19569 9.86171 3.19546 9.8616 3.19557C9.86171 3.19546 9.86216 3.19502 9.86227 3.19491L12.6667 0.390503ZM10.3333 4.60945L2.00001 12.9428L2.00001 14H3.0572L11.3905 5.66665L10.3333 4.60945ZM12.3333 4.72384L11.2761 3.66665L12.6667 2.27612L13.7239 3.33331L12.3333 4.72384Z",
    fill: "#697180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenHollow);
export default __webpack_public_path__ + "static/media/pen_hollow.a331027534c4268e1e3f3baf483ddeba.svg";
export { ForwardRef as ReactComponent };